import React from "react";
import { useAppSelector } from "../app/hooks";
import { SortOrder } from "../interfaces/types";

interface ArticleFiltersProps {
    filtersText: any;
    categoryFilterValues: string[];
    publishDateFilterValues: string[];
    appliedFilterCategories: string[];
    appliedPublishedDate: string;
    hasAppliedFilters: boolean;
    onResetFilters: () => void;
    onSortOrderChange: () => void;
    isTabletOrMobile: boolean;
    mobileFiltersExpanded: boolean;
}

export const ArticleFilters: React.FC<ArticleFiltersProps> = ({
    filtersText,
    appliedFilterCategories,
    onResetFilters,
    onCategoryChange,
    onSortOrderChange,
    appliedSortOrder,
    isTabletOrMobile,
    mobileFiltersExpanded,
}) => {
    const filters = useAppSelector(state => state.filters);
    console.log(filtersText);
    return (
        <div className="stack">
            <div className="article-filters-top">
                <div className="flex-between article-filters-heading">
                    <h2 className="h3-style visually-hidden">Filters</h2>
                </div>
            </div>
            <div className="article-listing-filters">
                {/* Categories */}
                {
                    filters.map((filter, index) => {
                        return <div>
                            <label htmlFor={`categoryList_${index}`}>{filter.label}</label>
                            <select tabIndex={isTabletOrMobile && !mobileFiltersExpanded ? -1 : null} id={`categoryList_${index}`} onChange={(e) => {
                                onCategoryChange(filter.label, e)
                            }}>
                                <option value="" selected={appliedFilterCategories.length === 0}>-- Select Category --</option>
                                {
                                    filter.values.map((option, index) => {
                                        return <option key={`categoryOption_${index}`} value={option}>{option}</option>
                                    })
                                }
                            </select>
                        </div>
                    })
                }
                {/* Sort Order */}
                <div>
                    <label htmlFor="articleSortOrder">Sort</label>
                    <select tabIndex={isTabletOrMobile && !mobileFiltersExpanded ? -1 : null} id="articleSortOrder" onChange={(e) => {
                        onSortOrderChange(e)
                    }}>
                        <option value={SortOrder.Newest} selected={appliedSortOrder === SortOrder.Newest}>Newest</option>
                        <option value={SortOrder.Oldest} selected={appliedSortOrder === SortOrder.Oldest}>Oldest</option>
                    </select>
                </div>
                <div className="article-listing-filters-clear">
                    <button onClick={onResetFilters} className="btn-link" tabIndex={isTabletOrMobile && !mobileFiltersExpanded ? -1 : null}>
                        {filtersText.clearFiltersLabel}
                    </button>
                </div>
            </div>
            
        </div>
    );
};
